<div
  class="d-flex justify-content-center loader flex-column align-items-center"
  *ngIf="loading"
>
  <div>
    <mat-spinner color="accent"></mat-spinner>
  </div>
</div>

<div class="row m-0 h-100 scrollable bg-decorative bg-black">
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-6">
        <mat-card class="m-3 bg-dark">
          <mat-card-header>
            <mat-card-title class="link"
              ><button
              mat-raised-button
              class="mr-2 text-white"
              color="primary"
              (click)="goTo('categories')"
            >Categories</button></mat-card-title
            >

            <div class="spacer"></div>
            <button
              class="mr-2"
              mat-mini-fab
              color="primary"
              aria-label="Find Category"
              (click)="findCategory()"
            >
              <fa-icon [icon]="faSearch" class="text-white"></fa-icon>
            </button>
            <button
              mat-mini-fab
              color="primary"
              aria-label="Create Category"
              (click)="createCategory()"
            >
              <fa-icon [icon]="faPlus" class="text-white"></fa-icon>
            </button>
          </mat-card-header>
          <mat-card-content>
            <div class="border-primary p-3 mb-3 mt-3 text-center d-flex justify-content-center">
              <h1 class="text-white">{{categoryCount}}</h1>
              <mat-spinner *ngIf="!categoryCount" color="accent"></mat-spinner>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-md-6">
        <mat-card class="m-3 bg-dark">
          <mat-card-header>
            <mat-card-title class="link" 
              ><button
              mat-raised-button
              class="mr-2 text-white"
              color="primary"
              (click)="goTo('businesses')"
            >Businesses</button></mat-card-title
            >

            <div class="spacer"></div>
            <button
              class="mr-2"
              mat-mini-fab
              color="primary"
              aria-label="Find Business"
              (click)="findBusiness()"
            >
              <fa-icon [icon]="faSearch" class="text-white"></fa-icon>
            </button>
            <button
              mat-mini-fab
              color="primary"
              aria-label="List My Business"
              (click)="createBusiness()"
            >
              <fa-icon [icon]="faPlus" class="text-white"></fa-icon>
            </button>
          </mat-card-header>
          <mat-card-content>
            <div class="border-primary p-3 mb-3 mt-3 text-center justify-content-center d-flex">
              <h1 class="text-white">{{businessesCount}}</h1>
              <mat-spinner *ngIf="!businessesCount" color="accent"></mat-spinner>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-md-6">
        <mat-card class="m-3 bg-dark">
          <mat-card-header>
            <mat-card-title class="text-white" 
              >Ads</mat-card-title
            >
          </mat-card-header>
          <mat-card-content>
            <div class="border-primary p-3 mb-3 mt-3 text-center justify-content-center d-flex">
              <h1 class="text-white">{{adCount}}</h1>
              <mat-spinner *ngIf="!adCount" color="accent"></mat-spinner>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-md-6">
        <mat-card class="m-3 bg-dark">
          <mat-card-header>
            <mat-card-title class="text-white" 
              ><button
              mat-raised-button
              class="mr-2 text-white"
              color="primary"
              (click)="goTo('users')"
            >Users</button></mat-card-title
            >
          </mat-card-header>
          <mat-card-content>
            <div class="border-primary p-3 mb-3 mt-3 text-center justify-content-center d-flex">
              <h1 class="text-white">{{userCount}}</h1>
              <mat-spinner *ngIf="!userCount" color="accent"></mat-spinner>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
  <div class="col-md-12">
  <div class="border-primary text-white mt-3">
    <h3 class="m-3">Overview</h3>
    <div *ngIf="barChartData.length !== 3"
    class="d-flex justify-content-center flex-column align-items-center"
  >
    <div>
      <mat-spinner color="accent"></mat-spinner>
    </div>
  </div>
    <app-bar-chart *ngIf="barChartData.length === 3" [title]="'Overview'" [barData]="barChartData"></app-bar-chart>
    </div>
  </div>
  </div>